<script lang="ts">
	import Main from "../../organisms/recruitments/Edit.svelte";
	export let params = {}
</script>

<div class="flex">
	<div class="flex-1">
		<Main params={params} />
	</div>
</div>